// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loader{position:fixed;top:0;left:0;display:flex;flex-direction:column;justify-content:center;align-items:center;width:100vw;height:100vh;z-index:999999;background-color:#00000080;pointer-events:none;transition:.2s}", ""]);
// Exports
module.exports = exports;
